import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { selectFundDistribution } from '../../../../store/fundDistribution/fundDistributionSlice';
// import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { columnsDistributionFund } from '../../../helpers/columnsFunds';
import { TableLayout } from '../../../layout/TableLayout';
import { EditDistributionFund } from './EditDistributionFund';
import { deleteFundDistribution } from '../../../helpers/fundDistribution';
import { CreateDivestmentLP } from '../../divestment/CreateDivestmentLP';

export const DistributionFundTable = ({ rows, setReloadData }) => {

    const { t } = useTranslation('global');
    const dispatch = useDispatch()
    const [openEdit, setOpenEdit] = useState(false);
    const [openCreateDivestment, setOpenCreateDivestment] = useState(false);

    const onEditClick = (e) => {
        dispatch(selectFundDistribution(e.row))
        setOpenEdit(true)
    }

    const onDeleteClick = async (e) => {
        await deleteFundDistribution(e, t('delete.successMsg'), t('delete.errorMsg'), t('delete.cancelButton'), t('delete.confirmButton'), t('delete.deleteConfirm'))
        setReloadData(prevState => !prevState)
    }

    const onDivestmentClick = async (e) => {
        dispatch(selectFundDistribution(e.row))
        setOpenCreateDivestment(true)
    }

    const columns = columnsDistributionFund(t, onDeleteClick, onEditClick, onDivestmentClick)

    return (
        <>
            <TableLayout
                rows={rows}
                columns={columns}
                title='distributionFundTable'
            />
            {
                openEdit &&
                <EditDistributionFund setHidden={setOpenEdit} setReloadData={setReloadData} />
            }
            {
                openCreateDivestment &&
                <CreateDivestmentLP setHidden={setOpenCreateDivestment} setReloadData={setReloadData}/>
            }
        </>
    )
}